import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { RECENT_ACTIVITY_PROFILE, RECENT_ACTIVITY_PROFILE_SUCCESS, RECENT_ACTIVITY_PROFILE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getRecentActivityProfile({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/activities?page_size=5&page_index=1`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: RECENT_ACTIVITY_PROFILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: RECENT_ACTIVITY_PROFILE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: RECENT_ACTIVITY_PROFILE_ERROR, payload: error });
  }
}

export function* watchRecentActivityProfile() {
  yield takeEvery(RECENT_ACTIVITY_PROFILE, getRecentActivityProfile);
}

function* watchRecentActivityProfileSaga() {
  yield all([fork(watchRecentActivityProfile)]);
}

export default watchRecentActivityProfileSaga;
